import { render, staticRenderFns } from "./ExaminerFeedbackModal.vue?vue&type=template&id=099e8484"
import script from "./ExaminerFeedbackModal.vue?vue&type=script&lang=ts"
export * from "./ExaminerFeedbackModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports